<template>
  <div class="flex flex-col vx-card relative">
    <Shimmer class="w-full h-full absolute" v-if="!chartDataLoaded"></Shimmer>
    <div
      class="flex px-4 gap-4 items-center p-3 z-10"
      style="max-width: max-content"
    >
      <h5 class="my-4">{{ $t("SalesPersonsPerformance") }}</h5>
      <!-- <img
        src="@/assets/images/shared/chevron-down.svg"
        @click="showChart = !showChart"
        class="rotate-img w-5"
        :class="{
          'transform rotate--180deg': showChart,
        }"
      /> -->
    </div>
    <div
      class="p-4 w-full h-full relative"
      style="min-height: 370px"
      v-if="showChart"
    >
      <vue-apex-charts
        v-if="chartDataLoaded"
        type="bar"
        :series="series"
        height="350"
        class="w-full absolute bottom-0 pl-3"
        :options="chartOptions"
      ></vue-apex-charts>
      <SalesPersonOrdersPerSegmentPopup
        :show="salesPersonOrdersPerSegmentPopup"
        @close="salesPersonOrdersPerSegmentPopup = false"
        :salesPersonData="selectedSalesPersonData"
        :dataLoading="ordersPerSegmentLoading"
      ></SalesPersonOrdersPerSegmentPopup>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { mapActions } from "vuex";
import Shimmer from "@/components/Shimmer.vue";
import SalesPersonOrdersPerSegmentPopup from "./SalesPersonOrdersPerSegmentPopup.vue";
export default {
  data() {
    return {
      showChart: true,
      chartDataLoaded: false,
      ordersPerSegmentOfSalesPersons: [],
      salesPersonOrdersPerSegmentPopup: false,
      selectedSalesPersonData: {},
      selectedConfig: {},
      ordersPerSegmentLoading: true,
      series: [
        {
          name: "میزان فروش",
          data: [],
          additionalData: [],
        },
        {
          name: "مانده تارگت",
          data: [],
          additionalData: [],
        },
      ],
      chartOptions: {
        colors: ["#2f9951", "#db8888"],
        legend: {
          markers: {
            width: 12,
            height: 12,
            radius: 12,
            offsetX: 5,
          },
        },
        yaxis: {
          labels: {
            show: false,
            offsetX: -10,
          },
        },
        // plotOptions: {
        //   bar: {
        //     columnWidth: "100%",
        //   },
        // },
        chart: {
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.openSegmentsPopup(config);
            },
          },
          type: "bar",
          height: 350,
          stacked: true,
          stackType: "100%",
          fontFamily: "IRANSans",
          toolbar: {
            show: false,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        xaxis: {
          categories: [],
          labels: {
            rotateAlways: true,
            hideOverlappingLabels: false,
            rotate: -80,
            style: {
              fontSize: "13px",
              cssClass: "no-hover",
              background: "inherit",
              "background-clip": "text",
              color: "transparent",
              filter: "invert(1)",
            },
            show: true,
            align: "left",
            offsetY: 60,
            offsetX: -4,
          },
        },
        fill: {
          opacity: 1,
        },
        grid: {
          show: false,
        },
      },
    };
  },
  methods: {
    ...mapActions({
      fetchOrdersOfSalesTargetsOfSalePersonsChartData:
        "reports/fetchOrdersOfSalesTargetsOfSalePersonsChartData",
      fetchOrdersPerSegmentAndSaleTargetsOfSalePersonsChartData:
        "reports/fetchOrdersPerSegmentAndSaleTargetsOfSalePersonsChartData",
    }),
    // calculateAndSetChart7BarWidth(seriesLength) {
    //   this.chartOptions.plotOptions.bar.columnWidth =
    //     20 + 60 / (1 + 40 * Math.exp(-seriesLength / 3)) + "%";
    // },
    openSegmentsPopup(config) {
      if (
        this.$tabHasPermission(
          "GetOrdersPerSegmentAndSaleTargetsOfSalePersonFromFirstOfThisMonth"
        )
      ) {
        this.selectedConfig = config;
        if (!this.ordersPerSegmentLoading) {
          this.setSelectedSalePersonData();
        }
        if (this.selectedSalesPersonData) {
          this.salesPersonOrdersPerSegmentPopup = true;
        }
      }
    },
    setSelectedSalePersonData() {
      const selectedSalesPersonName =
        this.series[0].additionalData[this.selectedConfig.dataPointIndex].name;
      this.selectedSalesPersonData = this.ordersPerSegmentOfSalesPersons.find(
        (item) => item.fullNameOfSalePerson === selectedSalesPersonName
      );
    },
  },
  mounted() {
    if (
      this.$tabHasPermission(
        "GetOrdersPerSegmentAndSaleTargetsOfSalePersonFromFirstOfThisMonth"
      )
    ) {
      this.fetchOrdersPerSegmentAndSaleTargetsOfSalePersonsChartData().then(
        (response) => {
          this.ordersPerSegmentLoading = false;
          this.ordersPerSegmentOfSalesPersons = response;
        }
      );
    }
    this.fetchOrdersOfSalesTargetsOfSalePersonsChartData().then((response) => {
      const dataArray = response.sort(
        (a, b) =>
          b.percentageOfTotalAmountOfSaleAgentTargets -
          a.percentageOfTotalAmountOfSaleAgentTargets
      );
      dataArray.forEach((item) => {
        if (!item.percentageOfTotalAmountOfSaleAgentTargets == 0) {
          const ordersPerTargetPercentage = Math.min(
            Math.round(item.percentOfOrdersAmount),
            100
          );
          this.series[0].data.push(ordersPerTargetPercentage);
          this.series[0].additionalData.push({
            name: item.fullNameOfSalePerson,
          });
          this.series[1].data.push(100 - ordersPerTargetPercentage);
          this.chartOptions.xaxis.categories.push(item.fullNameOfSalePerson);
        } else {
          this.chartOptions.xaxis.categories.push(item.fullNameOfSalePerson);
        }
      });

      this.chartDataLoaded = true;
    });
  },
  watch: {
    ordersPerSegmentLoading(newVal) {
      if (!newVal && this.salesPersonOrdersPerSegmentPopup) {
        this.setSelectedSalePersonData();
      }
    },
  },
  components: {
    VueApexCharts,
    Shimmer,
    SalesPersonOrdersPerSegmentPopup,
  },
};
</script>

<style>
.no-hover {
  pointer-events: none;
}
</style>
